/*
akhila    10/28/2022 3075154998 enable framework UX changes
*/
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddFilterGroup from './AddFilterGroup';
import SearchFilterGroup from './SearchFilterGroup';
const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
}));

export default function RuleGroupTabs() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [filterGroupCode, setFilterGroupCode] = useState(null);
  const [isCopyRowData, setIsCopyRowData] = useState(false);
  return (
    <div className={classes.root}>
      <div className={classes.searchRuleButton}>
        <Typography />
      </div>
      <div className={classes.subContent}>
        {value === 0 ? (
          <SearchFilterGroup
            setTabValue={setValue}
            setFilterGroupCode={setFilterGroupCode}
            setIsCopyRowData={setIsCopyRowData}
          />
        ) :
          value === 1 ? (
            <AddFilterGroup
              setValue={setValue}
              filterGroupCode={filterGroupCode}
              setFilterGroupCode={setFilterGroupCode}
              isCopyRowData={isCopyRowData}
            />
          ) : null}
      </div>
    </div>
  );
}
